import Vue from 'vue';
import Router from 'vue-router';
import Page from './views/Page.vue';
import Intro from './views/Intro.vue';
import Embed from './views/Embed.vue';
import Privacy from './views/Privacy.vue';
import RealFinish from './components/FinishForReal.vue';
import RealFinishNoForm from './components/FinishForReal_NoForm.vue';

Vue.use(Router);

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			name: 'home',
			component: Intro,
		},
		{
			path: '/page/:id',
			name: 'page',
			component: Page,
		},
		{
			path: '/embed',
			name: 'embed',
			component: Embed,
		},
		{
			path: '/privacy',
			name: 'privacy',
			component: Privacy,
		},
		{
			path: '/finished_form',
			name: 'finished_form',
			component: RealFinish,
		},
		{
			path: '/finished_noform',
			name: 'finished_noform',
			component: RealFinishNoForm,
		},
	],
});

router.beforeEach((to, from, next) => {
	const hasQueryParams = route => !!Object.keys(route.query).length;

	if (!hasQueryParams(to) && hasQueryParams(from)) {
		next({
			...to,
			query: from.query,
		});
	} else {
		next();
	}
});

export default router;
